import SolutionsPage from 'client/common/pages/solutions';

import './index.css';

export default SolutionsPage;
